import { z } from "zod";

export const createNewUserSchema = z.object({
  usuario: z
    .object({
      first_name: z.string(),
      id: z.number().nullable(),
      last_name: z.string(),
      username: z.string(),
    })
    .nullable()
    .refine((val) => val !== null, {
      message: "CPF do usuário é obrigatório",
    }),
  setor_data: z
    .object({
      setor: z.object({
        id: z.number().nullable(),
        nome: z.string(),
        sigla: z.string(),
      }),
    })
    .nullable()
    .refine((val) => val !== null, {
      message: "Setor é obrigatório",
    })
    .optional(),
  misto: z.boolean().optional(),
});

export type CreateUsersSchemaData = z.infer<typeof createNewUserSchema>;
